import proreq from '../proto/request_pb'
import proresp from '../proto/response_pb'

const Handles = {
  ctx: null,

  init(ctx) {
    this.ctx = ctx;
  },

  onConnected(event) {

  },

  handProto(packet) {
    this.ctx.$logger.log('socket 收到消息 ', packet)
    if(packet.errcode > 0){
      switch (packet.errcode) {
        case 1301://对方已不是你的好友
          this.ctx.$store.commit('showTipDialog', {msg: '对方已经不是你的好友,请重新发送好友请求!', btn: '知道了', outCancel: true})
          break;
        case 3003:
          this.ctx.$store.commit('naveTo', {vue: this.ctx, path: this.ctx.$router_path.login});
          break;
        case 2007:
          this.ctx.$store.commit('naveTo', {vue: this.ctx, path: this.ctx.$router_path.login});
          break;
      }
      return ;
    }
    const code = packet.code
    switch (code) {
      case 2000:
        this.onRecvSelfResp(packet.uuid, proto.proresp.MsgAckReponse.deserializeBinary(packet.databytes).toObject())
        break;

      case 2001:
        this.onRecvFriendReq(packet,proto.proresp.AskResponse.deserializeBinary(packet.databytes).toObject())
        break;
      case 2002:

        break;
      case 2003:
        this.onRecvFriendAdd(packet, proto.proresp.FriendResponse.deserializeBinary(packet.databytes).toObject())

        break;

      case 2006:
        this.onRecvSelfGroupResp(packet.uuid, proto.proresp.MsgAckReponse.deserializeBinary(packet.databytes).toObject())
        break;
      case 2011:
        this.onRecvGroupMsg(packet, proto.proresp.BroadMsgReponse.deserializeBinary(packet.databytes).toObject())
        break;

      case 2007:
        this.onRecvChatMsg(packet, proto.proresp.PointMsgReponse.deserializeBinary(packet.databytes).toObject())

        break;
      case 2009:

        break;

      case 2013:
        this.onRecvBarrageMsg(packet, proto.proresp.BarrageArr.deserializeBinary(packet.databytes).toObject())
        break;

      // 任务完成
      case 2015:
        this.onRecvReceiveRewardMsg(packet, proto.proresp.TaskFinishNotify.deserializeBinary(packet.databytes).toObject())
        break;
    }
  },

  //黑名单请求
  onRecvRefuseReq(data) {
    this.ctx.$logger.log('socket 收到黑名单 ', data)
    try{
      if(this._refuseRecvHandler){
        this._refuseRecvHandler(data)
      }
    }catch (e) {
      this.ctx.$logger.error(e)
    }
    this.ctx.$websql.addRefuse(data)
  },

  _refuseRecvHandler: null,
  setRefuseRecvHandler(handler){
    this._refuseRecvHandler = handler
  },

  //好友请求
  onRecvFriendReq(packet,data) {
    this.ctx.$logger.log('socket 收到好友请求 ', data)
    data.friend.reqId = data.id
    try{
      if(this._friReqRecvHandler){
        this._friReqRecvHandler(data.friend)
      }
    }catch (e) {
      this.ctx.$logger.error(e)
    }
    this.ctx.$websql.addFriendReq(data.friend)

    this.ctx.$http_data.friendAck(packet.uuid)
  },

  _friReqRecvHandler: null,
  setFriReqRecvHandler(handler){
    this._friReqRecvHandler = handler
  },

  onRecvFriendAdd(packet, data) {
    this.ctx.$logger.log('socket 收到新的好友 ', data)

    try{
      data.userNo = data.uid
      if(this._friRecvHandler){
        this._friRecvHandler(data)
      }
    }catch (e) {
      this.ctx.$logger.error(e)
    }
    this.ctx.$websql.addFriend(data)

    this.ctx.$http_data.friendAck(packet.uuid)
  },

  _friRecvHandler: null,
  setFriRecvHandler(handler){
    this._friRecvHandler = handler
  },

  onRecvGroupMsg(packet, data) {
    this.ctx.$logger.log('socket 收到群消息 ', data)

    let item = {}
    item["group"] = data.groupid
    item["msgno"] = data.msgno;
    item["time"] = data.time;
    item["sender"] = data.senderid
    item["type"] = data.type
    item["context"] = data.context
    item["off"] = data.off

    item["owner"] = item["group"]

    console.log(' xxx   ', item)
    try{
      if(this._msgRecvHandler){
        this._msgRecvHandler(item)
      }
    }catch (e) {
      this.ctx.$logger.error(e)
    }
    this.ctx.$websql.addGroupChatMsg(item)
    this.ctx.$socket.sendGroupAckMsg(packet.uuid, item["group"], item.off)
  },

  onRecvSelfGroupResp(uuid, data) {
    this.ctx.$logger.log('socket 收到 群 自己消息 ', data)

    if(this._msgMap.has(uuid)){
      let obj = this._msgMap.get(uuid)
      this._msgMap.delete(uuid)

      let item = {}
      item["msgno"] = data.msgno;
      item["time"] = data.time;
      item["sender"] = this.ctx.$info.id
      item["group"] = obj.data.getTargetid()
      item["type"] = obj.data.getType()
      item["context"] = obj.data.getContext()
      item["off"] = false

      item["owner"] = item["group"]

      obj.cb(item)

      this.ctx.$websql.addGroupChatMsg(item)
    }
  },

  onRecvChatMsg(packet, data) {
    this.ctx.$logger.log('socket 收到新的消息 ', data)

    let item = {}
    item["msgno"] = data.msgno;
    item["time"] = data.time;
    item["sender"] = data.senderid
    item["target"] = this.ctx.$info.id
    item["type"] = data.type
    item["context"] = data.context
    item["off"] = data.off

    if(item["sender"] > item["target"]){
      item["owner"] = item["target"] + '_' + item["sender"]
    }else{
      item["owner"] = item["sender"] + '_' + item["target"]
    }

    try{
      if(this._msgRecvHandler){
        this._msgRecvHandler(item)
      }
    }catch (e) {
      this.ctx.$logger.error(e)
    }
    this.ctx.$websql.addSingleChatMsg(item)
    this.ctx.$socket.sendAckMsg(packet.uuid, item["target"], item.off)
  },

  _msgRecvHandler: null,
  setMsgRecvHandler(handler){
    this._msgRecvHandler = handler
  },

  onRecvSelfResp(uuid, data) {
    this.ctx.$logger.log('socket 收到自己消息 ', data)

    if(this._msgMap.has(uuid)){
      let obj = this._msgMap.get(uuid)
      this._msgMap.delete(uuid)

      let item = {}
      item["msgno"] = data.msgno;
      item["time"] = data.time;
      item["sender"] = this.ctx.$info.id
      item["target"] = obj.data.getTargetid()
      item["type"] = obj.data.getType()
      item["context"] = obj.data.getContext()
      item["off"] = false

      if(item["sender"] > item["target"]){
        item["owner"] = item["target"] + '_' + item["sender"]
      }else{
        item["owner"] = item["sender"] + '_' + item["target"]
      }

      obj.cb(item)

      this.ctx.$websql.addSingleChatMsg(item)
    }
  },

  _msgMap: new Map(),
  addSelfMsgCB(uuid, data, cb){
      this._msgMap.set(uuid, {data: data, cb: cb})
  },



  onRecvBarrageMsg(packet, data) {
    this.ctx.$logger.log('socket 收到弹幕 ', data)
    try{
      if(this._barrageRecvHandler){
        this._barrageRecvHandler(data)
      }
    }catch (e) {
      this.ctx.$logger.error(e)
    }
  },
  _barrageRecvHandler: null,
  setBarrageRecvHandler(handler){
    this._barrageRecvHandler = handler
  },
  //任务完成,领取奖励信息
  onRecvReceiveRewardMsg(packet, data){
    //任务完成通知
    this.ctx.$logger.log('任务完成')
    this.ctx.$logger.log(data)
    this.ctx.$store.state.showReceiveReward({title: data.tasktype,type: data.prizetype,condition: data.content});
  }



}


Handles.install = function (Vue, options) {
  Vue.prototype.$handles = Handles
}
export default Handles;



// WEBPACK FOOTER //
// ./src/plugins/net-socket-handler.js